export default __webpack_public_path__ + "static/ay-support-content-performance-ea68f1db6d1d87ab0f00a7a219dc3af5.svg";